var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('v-main',{staticClass:"pa-0"},[_c('router-view')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }